import React, { useState, useEffect, useContext } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import _path from 'ramda/src/path';
import Button from '../Common/Button';
import { withMessage } from '../Common/Message';
import UserGroup from '../../API/UserGroup';
import LogglyLogger from '../../API/Loggly';
import resx from '../../utilities/resx';
import GeneralUtility from '../../utilities/generalUtility';
import { RESX_GLOBAL, LOGGLY_LEVEL_ERROR } from '../../Constants';
import { GroupContext } from './GroupContext';

const JoinGroup = ({ buttonFullWidth, message }) => {
    const [submitting, setSubmitting] = useState(false);
    const [showBtn, setShowBtn] = useState(false);
    const { pathname } = useLocation();
    const groupContext = useContext(GroupContext);
    const isUltimateUser = _path(['RESAAS', 'User2', 'PremiumPlus'], window);

    const pendingRequests = [];

    useEffect(() => {
        return () => {
            GeneralUtility.cleanupRequests(pendingRequests);
        };
    }, []);

    const handleJoinGroup = () => {
        setSubmitting(true);

        const joinGroup = UserGroup.joinGroup({
            GroupUniqueName: groupContext.currentGroup.GroupUniqueName
        });
        GeneralUtility.appendPendingRequest(pendingRequests, joinGroup);

        joinGroup
            .then(response => {
                if (response.data.Success) {
                    setSubmitting(false);
                    window.location.assign(pathname);
                } else {
                    throw new Error(response.data.Message);
                }
            })
            .catch(error => {
                message.addMessage({
                    message: 'Unable to join group at this time, please try again or <a href="mailto:support@resaas.com">support@resaas.com</a>',
                    type: 'error',
                    autoDelete: false
                });

                LogglyLogger.add(LOGGLY_LEVEL_ERROR, 'UserGroup.joinGroup from joinGroup component', error);
                setSubmitting(false);
            });
    };

    useEffect(() => {
        if (
            groupContext.currentGroup &&
            groupContext.currentGroup.GroupPrivacyType === 0 &&
            !groupContext.isGroupMember() &&
            (!groupContext.isUltimateOnlyGroup() || (groupContext.isUltimateOnlyGroup() && isUltimateUser))
        ) {
            setShowBtn(true);
        }
    }, [groupContext]);

    return (
        <React.Fragment>
            {showBtn ? (
                <div className="re-group-widget-tools-items" data-testid="groupjoin">
                     <Button
                        className={`re-btn re-btn-small re-btn-whiten re-icon re-icon-sm re-icon-connection re-group-widget-tools-item ${buttonFullWidth ? 're-btn-full-width' : ''}`}
                        dataTestid="joinGroup"
                        type="button"
                        loading={submitting}
                        text={resx(RESX_GLOBAL, 'JOIN_GROUP_TEXT')}
                        onClick={handleJoinGroup}
                    />
                </div>
            ) : null}
        </React.Fragment>
    );
};

JoinGroup.propTypes = {
    buttonFullWidth: PropTypes.bool,
    message: PropTypes.object
};

JoinGroup.defaultProps = {
    buttonFullWidth: true
};

export default withMessage(JoinGroup);
